<div class="content-dashboard">
  <div class="dashboard-header">
    <div class="title">
      <i class="fab fa-whatsapp"></i>
      <h1>{{'whatsapp_dashboard' | translate}}</h1>
    </div>
    <h6 class="dashboard-subtitle">
      @if(!filtersActive){
      <p>Mostrando información acumulada del Mes actual</p>
      }@else {
      @if(inicio.value === fin.value){
      <p>Mostrando información acumulada del {{inicio.value}}</p>
      }@else {
      <p>{{'accumulated_info_range' | translate | replacePlaceholders: [inicio.value, fin.value] }}</p>
      }
      }
    </h6>
  </div>



  <div class="filters-content">
    <div class="filters-range">
      <app-so-button-group-radio id='' [ngStyle]="{'margin-top':'21px'}" [data]="filters"
        (filterClicked)="activar($event)"></app-so-button-group-radio>
      @if(filtersActive){
      <div class="filters">
        <app-so-input-form id="inicio" [formGroup]="formFilters" name="inicio" label="Fecha inicio" type="date"
          (change)="applyFilters()"></app-so-input-form>
        <app-so-input-form id="fin" [formGroup]="formFilters" name="fin" label="Fecha fin" type="date"
          (change)="applyFilters()"></app-so-input-form>
      </div>
      }
    </div>

  </div>



  <div class="dashboard-alerts">
    <div class="alert-item" *ngFor="let items of dashboard_ws_Indicators">
      <div class="alert-content" [ngStyle]="{'cursor':items.key ? 'pointer' : ''}"
        [ngClass]="items.key ? 'transform':''" (click)="openModal(items)">
        <so-icon svg="{{items.icon}}" [size]="0.8" />
        <h6 class="alert-title">{{items.title|translate}}</h6>
        <app-so-badge class="alert-badge" text="{{items.value}}" [isCircle]="true"
          [ngStyle]="{ width: '2.5em', height: '2.5em' }" color="second-white"></app-so-badge>
      </div>
    </div>
  </div>

  <div class="dashboard-main">
    <div class="dashboard-column">
      <app-so-card [ngStyle]="{'height':'343px'}">
        <div class="card-header">
          <h1 class="card-title">{{'messages_status'|translate}} </h1>
        </div>
        <app-so-chart-doughnut [id]="'Status'" [data]="StatusMesajes()" [footerNumber]="totalMesajes+''"
          footer="{{'total_of_messages'|translate}}"></app-so-chart-doughnut>
      </app-so-card>

      <div class="dashboard-subcard">
        <app-so-card>
          <div class="card-subheader">
            <h1 class="card-title">
              <app-so-replace [text]="'unregister_prospect_formatted' | translate"
                [replacement]="sinRegistrar?.length"></app-so-replace>
            </h1>
            <!-- <h6 class="dashboard-subtitle">{{'register_in_next_table'|translate}}</h6> -->
          </div>
        </app-so-card>
      </div>
    </div>

    <div class="dashboard-column">
      <app-so-card>
        <div class="card-header">
          <h1 class="card-title">{{'conversations_status'|translate}}</h1>
        </div>

        <div class="conversation-summary">
          <so-icon svg="chat-config" [size]="0.8" />
          <h6 class="conversation-title">{{'conversations'|translate}}</h6>
          <app-so-badge [text]="totalConversaciones+''" [isCircle]="true" color="second-white"></app-so-badge>
        </div>

        <div class="conversation-charts">
          <div class="chart-item">
            <app-so-chart-doughnut-simple [id]="'conversationsUnanswered'" [data]="conversationsUnanswered"
              title="{{'unanswered_conversations'|translate}}" color="primary"
              [footer]="conversationsUnanswered[0] + '/' + conversationsUnanswered[1]">
            </app-so-chart-doughnut-simple>
          </div>

          <div class="chart-item">
            <app-so-chart-doughnut-simple [id]="'conversationsWithoutClient'" [data]="conversationsWithoutClient"
              title="{{'client_unanswered_conversations'|translate}}" color="success"
              [footer]="conversationsWithoutClient[0] + '/' + conversationsWithoutClient[1]">
            </app-so-chart-doughnut-simple>
          </div>
        </div>
      </app-so-card>
    </div>
  </div>

  <app-so-card>
    <div class="table-section">
      <app-dynamic-table idTable="table-detalles-prospectos" [data]="data" [columns]="columns" [loading]="loading"
        (buttonClick)="onButtonClick($event)" (linkClick)="onLinkClick($event)"></app-dynamic-table>
    </div>
  </app-so-card>




  <div id="dynamic-tabs-root"></div>


  <app-modal-conversations [data]="dataModal" [title]="titleModal"></app-modal-conversations>
